import { ILocation } from '@rbi-ctg/frontend';
import { IStore } from '@rbi-ctg/store';
import { ServiceMode } from 'state/order';
import { milesBetweenCoordinates } from 'utils/restaurant';

export const sortByDistance = (a: IStore, b: IStore) => {
  if (b?.distanceInMiles && b.distanceInMiles > (a?.distanceInMiles || Infinity)) {
    return -1;
  }
  if (a?.distanceInMiles && a.distanceInMiles > (b?.distanceInMiles || Infinity)) {
    return 1;
  }
  return 0;
};

export const addDistanceFromUserCoordinates = (
  store: IStore,
  activeCoordinates: ILocation | null
) => {
  if (!activeCoordinates) {
    return store;
  }
  const distanceInMiles = milesBetweenCoordinates(activeCoordinates, {
    lat: store.latitude,
    lng: store.longitude,
  });
  return {
    ...store,
    distanceInMiles,
  };
};

export const filterStoresForServiceMode = (stores: IStore[], serviceMode: ServiceMode) => {
  switch (serviceMode) {
    case ServiceMode.CATERING_PICKUP:
    case ServiceMode.CATERING_DELIVERY:
      return stores.filter(store => store.hasCatering);
    default:
      return stores;
  }
};

export const filterByServiceModeAndSortByDistance = (
  stores: IStore[] = [],
  serviceMode: ServiceMode,
  activeCoordinates: ILocation | null
) => {
  return filterStoresForServiceMode(stores, serviceMode)
    .map(store => addDistanceFromUserCoordinates(store, activeCoordinates))
    .sort(sortByDistance);
};
